import { DeliveryWindow as ClientCartDeliveryWindow } from "@nuorder/client-cart-api/dist/types/modules/availability/models";
import { DeliveryWindow } from "records/item/delivery-window";

/**
 * Converts Client Cart Delivery Window to Delivery Window
 * TODO: remove when standard DeliveryWindow is used within GridView
 */
export const toDeliveryWindow = (dw: ClientCartDeliveryWindow): DeliveryWindow =>
    new DeliveryWindow({
        _id: undefined,
        display_name: dw.displayName,
        type: dw.type,
        prebook: dw.prebook,
        adjustable_dates: dw.adjustableDates,
        start: dw.startDate,
        end: dw.endDate,
        earliest_available_date: dw.earliestAvailableDate,
        latest_available_date: dw.latestAvailableDate,
    });
